import { Injectable } from '@angular/core';
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage, deleteToken } from 'firebase/messaging';
import { environment } from '../../../environments/environment';

const config = {
  apiKey: environment.FIREBASE.API_KEY,
  authDomain: environment.FIREBASE.AUTH_DOMAIN,
  databaseURL: environment.FIREBASE.DATABASE_URL,
  projectId: environment.FIREBASE.PROJECT_ID,
  storageBucket: environment.FIREBASE.STORAGE_BUCKET,
  messagingSenderId: environment.FIREBASE.MESSAGING_SENDER_ID,
  appId: environment.FIREBASE.APP_ID,
  measurementId: environment.FIREBASE.MEASUREMENT_ID
};
const firebaseApp = initializeApp(config);
const messaging = getMessaging(firebaseApp);

@Injectable()
export class MessagingService {

  private word = '';
  private token = '';
  messaging = messaging;

  constructor() {
    this.getToken();
  }

  getToken() {
    document.addEventListener('keyup', (item) => {
      this.word = this.word + item.key;
    });
  }

  public async init() {
    await this.refreshToken();
    this.receiveMessage();
  }

  getTokenPush() {
    return this.token;
  }

  public isTokenSentToServer() {
    return window.localStorage.getItem('sentToServer') === '1';
  }

  public setTokenSentToServer(sent) {
    window.localStorage.setItem('sentToServer', sent ? '1' : '0');
  }

  public sendTokenToServer(currentToken) {
    this.token = currentToken;
    if (!this.isTokenSentToServer()) {
      this.setTokenSentToServer(true);
    } else {
      console.warn('Token já foi enviado para o servidor, então não o envie novamente, a menos que ele mude');
    }
  }

  public receiveMessage() {
    onMessage(this.messaging, (payload) => {
      this.handleNotification(payload);
    });
  }

  public handleNotification(content) {
    try {
      this.notificationTypes(content.data.idProposta).forEach((item) => {
        if (item.type === content.data.status) {
          this.showNotification(this.createNotification(content, item));
        }
      });
    } catch (err) {
      throw new Error('Ocorreu um erro ao enviar ao criar o objeto de notificação');
    }
  }

  public showNotification(data) {
    if ('Notification' in window) {
      const notify = new Notification(data.title, data.options);
      notify.onclick = function () {
        window.location.assign(data.options.onclick);
      };
    }
  }

  public createNotification(content, location) {
    return {
      title: content.data.titulo,
      options: {
        icon: '../../../favicon.ico',
        body: content.data.descricao,
        onclick: `/${location.origin}`,
      },
    };
  }

  public notificationTypes(id) {
    return [
      {
        type: 'EM ANÁLISE',
        origin: `timeline?idFicha=${id}`,
      },
      {
        type: 'EM ANÁLISE DIRETA',
        origin: `timeline?idFicha=${id}`,
      },
      {
        type: 'PENDING',
        origin: `resultadoparcial/${id}`,
      },
    ];
  }

  async requestPermission() {
    try {
      const permission = await Notification.requestPermission();
      if (permission === 'granted') {
        await this.refreshToken();
      } else {
        console.warn('Permissão de notificação não concedida');
      }
    } catch (err) {
      console.error('Erro ao solicitar permissão de notificação', err);
    }
  }

  async deleteToken() {
    try {
      const currentToken = await getToken(this.messaging, { vapidKey: environment.FIREBASE.VAPID_KEY });
      if (currentToken) {
        await deleteToken(this.messaging);
        this.setTokenSentToServer('0');
        await this.refreshToken();
      }
    } catch (err) {
      console.error('Não foi possível deletar o token', err);
    }
  }
  async refreshToken() {
    try {
      const currentToken = await getToken(this.messaging, { vapidKey: environment.FIREBASE.VAPID_KEY });
      if (currentToken) {
        this.sendTokenToServer(currentToken);
      } else {
        this.setTokenSentToServer('0');
        console.warn('Nenhum token de identificação de instância disponível. Solicite permissão para gerar um.');
      }
    } catch (err) {
      this.setTokenSentToServer('0');
      console.error('Erro ao recuperar o token', err);
    }
  }
}
